/* this file is automatically generated.  edit at your own peril */
/* copyright 2015 Minted LLC.  All rights reserved */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:template': [],
  'minted:vendor/underscore-1.8.2.min': '_',
})(this, function (m_module, m_template, _) {
var M = m_module.M;

M.Template || (M.Template = {});
M.Template.ProductDetail || (M.Template.ProductDetail = {});

M.Template.ProductDetail.AccessoryPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<h6>MATCHING ITEMS</h6>\n<ul>\n  ';
 _.each(accessories, function(accessory, idx) { 
__p+='\n    <li>\n      <a class="accessoryOption" data-id="'+
((__t=( accessory.get('id') ))==null?'':__t)+
'">\n        '+
((__t=( accessory.get('description') ))==null?'':__t)+
'\n      </a>\n    </li>\n  ';
 }); 
__p+='\n</ul>\n';
}
return __p;
});

M.Template.ProductDetail.AddToCartDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/**
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n<ul class="bullet">\n  ';
 if (isCustomizableArt) { 
__p+='\n    <li>Dimensions shown refer to paper size, not the printed image.</li>\n    <li>We leave a minimum border of at least 0.5 inch for framing.</li>\n    <li>Printed on 100% archival matte, non-glossy paper, the standard used for Minted’s fine art prints.\n    </li>\n    ';
 if (isNonProofed) { 
__p+='\n      <li>I understand that Minted will not create a digital\n        proof of my item. Minted is not responsible for any image\n        or textual errors.\n      </li>\n    ';
 } else { 
__p+='\n      <li>You will receive an email in 1-2 business days when your proof\n        is ready for review. After you review and approve your proof,\n        your order will be sent to print.\n      </li>\n    ';
 } 
__p+='\n  ';
 } else { 
__p+='\n    <li>Dimensions shown refer to paper size, not the printed image.</li>\n    <li>We leave a minimum border of at least 0.5 inch for framing.</li>\n    <li>This art print is printed on archival matte paper, not photographic paper.\n    </li>\n    ';
 if (isLimitedEdition) { 
__p+='\n      <li>This art print is one edition of a limited print run of 350. An edition\n        is a limited run of a particular artwork and consists of a set number of\n        prints of each size and colorway.\n      </li>\n    ';
 } 
__p+='\n  ';
 } 
__p+='\n  ';
 if (hasArtistSignature && signatureStr === "artistSignature") { 
__p+='\n    <li>You\'ve opted to include a signature by the artist</li>\n  ';
 } else if (hasArtistSignature && signatureStr === "stockSignature") { 
__p+='\n    <li>You\\ve opted to include authentication by the artist</li>\n  ';
 } 
__p+='\n\n</ul>\n<form class="approve-form">\n  <div class="fieldWrapper approve-wrapper">\n    <input type="checkbox" id="approveAddToCart" />\n    <label for="approveAddToCart">Yes, this is great.</label>\n  </div>\n  <p class="warning" style="display:none;">\n    Please check the box in order to add this item to your cart.\n  </p>\n</form>\n\n<ul class="buttons">\n  <li><a class="addCartButton button primary h30">\n    <span>add to cart</span></a></li>\n  <li><a class="cancelButton button button-link cancel h30">\n    <span>cancel</span></a></li>\n\n</ul>\n';
}
return __p;
});

M.Template.ProductDetail.ArtColorPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h6>COLOR</h6>\n<ul id="colorPicker" class="inline nm" style="height:38px;overflow:hidden;">\n  ';
 _.each(colors, function(color, idx) { 
__p+='\n    <li class="swatch" data-id="'+
((__t=( color.get('id') ))==null?'':__t)+
'"\n        data-color-id="'+
((__t=( color.get('color_id') ))==null?'':__t)+
'"\n        data-foil-color="'+
((__t=( color.get('foil_color') ))==null?'':__t)+
'"\n        title="'+
((__t=( color.get('label') ))==null?'':__t)+
'">\n      <div class="colorPickerColor" style="background-color:'+
((__t=( color.get('rgb') ))==null?'':__t)+
';">\n        <img src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n      </div>\n    </li>\n  ';
 }); 
__p+='\n</ul>\n<p class="colorLabel nm floatL" style="font-weight:bold;"></p>\n<p class="floatR"><a class="showMoreColors" style="visibility:visible;">show more colors</a></p>';
}
return __p;
});

M.Template.ProductDetail.ArtDimensionOption = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td class="dimension">'+
((__t=( model.get('dimensions') ))==null?'':__t)+
'</td>\n<td class="amountLeft caption">\n  '+
((__t=( model.getAmountLeftForColor(selectedColorIdx) ))==null?'':__t)+
'\n</td>\n<td>\n  <input type="radio" class="skuUnframed" value="'+
((__t=( model.get('sku') ))==null?'':__t)+
'"\n    data-framed="0" name="'+
((__t=( model.get('sku') ))==null?'':__t)+
'-unframed"\n    ';
 if (model.get('unframedChecked')) { 
__p+=' checked="checked" ';
 } 
__p+=' />\n  <label for="'+
((__t=( model.get('sku') ))==null?'':__t)+
'-unframed">\n    <b>'+
((__t=( model.get('unframedPrice') ))==null?'':__t)+
'</b>\n  </label>\n</td>\n<td>\n  ';
 if (model.get('canFrame')) { 
__p+='\n    <input type="radio" class="skuFramed"\n      value="'+
((__t=( model.get('sku') ))==null?'':__t)+
'" data-framed="1"\n      name="'+
((__t=( model.get('sku') ))==null?'':__t)+
'-framed"\n      ';
 if (model.get('framedChecked')) { 
__p+=' checked="checked" ';
 } 
__p+=' />\n    <label for="'+
((__t=( model.get('sku') ))==null?'':__t)+
'-framed">\n      <b>'+
((__t=( model.get('allFramedPrices')[selectedFrameOptionId]))==null?'':__t)+
'</b>\n    </label>\n  ';
 } 
__p+='\n</td>';
}
return __p;
});

M.Template.ProductDetail.ArtDimensionPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<thead>\n  <tr>\n    <th colspan="2" style="width: 160px;"><h6>SELECT A SIZE</h6></th>\n    <th style="width: 90px;"><h6>UNFRAMED</h6></th>\n    <th style="width: 110px;">\n      ';
 if (hasFrameableDimensions) {
__p+='\n        <h6>WITH FRAME</h6>\n      ';
 } 
__p+='\n    </th>\n  </tr>\n</thead>\n<tbody></tbody>';
}
return __p;
});

M.Template.ProductDetail.ArtFoilBadge = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a>\n<img class="sprite foilPressSeeItMove '+
((__t=( M.html.htmlAttributeEscape(foilColor) ))==null?'':__t)+
'"\n     src="'+
((__t=( M.html.htmlAttributeEscape(M.sprite_placeholder()) ))==null?'':__t)+
'">\n</a>\n';
}
return __p;
});

M.Template.ProductDetail.ArtFoilImageDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<img class="imageFeature" src="'+
((__t=( M.html.htmlAttributeEscape(imageUrl) ))==null?'':__t)+
'" />\n<img style="display:none;position:absolute;left:40%;top:40%;"\n  class="sprite playPauseButton pauseButton"\n  src="'+
((__t=( M.html.htmlAttributeEscape(M.sprite_placeholder()) ))==null?'':__t)+
'" />';
}
return __p;
});

M.Template.ProductDetail.ArtFrameColorPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h6>FRAME</h6>\n<ul class="inline nm">\n  ';
 _.each(colors, function(color, idx) { 
__p+='\n    <li class="swatch" data-frame-color-id="'+
((__t=( color.get('id') ))==null?'':__t)+
'"\n        title="'+
((__t=( color.get('label') ))==null?'':__t)+
'"\n        data-recommended="'+
((__t=( color.get('recommended') ))==null?'':__t)+
'">\n      <div class="frameColor" style="background-color:#'+
((__t=( color.get('rgb') ))==null?'':__t)+
';">\n        <img src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n         class="'+
((__t=( color.get('internal_name')))==null?'':__t)+
'" />\n      </div>\n    </li>\n  ';
 }); 
__p+='\n</ul>\n<p class="frameColorLabel">\n  <span class="frameColorLabelText"></span>\n  <span class="frameDescriptionTeaser caption"></span>\n  <span class="frameDescription caption" style="display:none;"></span>\n  <a class="moreFrameDescription">more</a>\n</p>\n\n';
}
return __p;
});

M.Template.ProductDetail.ArtFrameColorSizeSoldOutDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n  The '+
((__t=( M.html.htmlAttributeEscape(frameName) ))==null?'':__t)+
'\n  frame is temporarily out of stock in your selected size.\n  Select another size to see if the frame is available or\n  choose a different frame type.\n</div>\n<div class="floatR">\n  <a class="button buttonPrimary buttonMedium">\n    ok\n  </a>\n</div>';
}
return __p;
});

M.Template.ProductDetail.ArtFrameColorSoldOutToolTip = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="'+
((__t=( M.html.htmlAttributeEscape(className) ))==null?'':__t)+
' toolTip">\n  <h6 class="soldOutText">'+
((__t=( M.html.htmlAttributeEscape(message) ))==null?'':__t)+
'</h6>\n  <div class="downArrow"></div>\n</div>';
}
return __p;
});

M.Template.ProductDetail.ArtFramesCompletelySoldOut = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n  You may buy this art print without a frame or check back later.\n</div>\n<div class="floatR">\n  <a class="button buttonPrimary buttonMedium">\n    ok\n  </a>\n</div>';
}
return __p;
});

M.Template.ProductDetail.ArtPaperPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h6>MATERIALS</h6>\n<div class="dropdownTarget"></div>\n<img style="margin-left:5px;cursor:pointer;" class="sprite infoIcon"\n  src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />';
}
return __p;
});

M.Template.ProductDetail.ArtSignaturePicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h6>ARTIST SIGNATURE</h6>\n<ul class="nm">\n  <li>\n    <label>\n      <input type="checkbox" name="signatureOption" value="'+
((__t=( artistSignatureType ))==null?'':__t)+
'" />\n      <b>'+
((__t=( M.html.htmlAttributeEscape(signatureTitle) ))==null?'':__t)+
'</b>\n      <span class="caption">\n        '+
((__t=( M.html.htmlAttributeEscape(signatureCaption) ))==null?'':__t)+
'\n      </span>\n    </label>\n  </li>\n</ul>';
}
return __p;
});

M.Template.ProductDetail.ColorPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<h6>COLORS</h6>\n<ul class="inline">\n  ';
 _.each(colors, function(color, idx) { 
__p+='\n    <li class="swatch color';
 if (color.get('displayFoilSwatch')) { 
__p+=' foilSwatch '+
((__t=( color.get('foilColor') ))==null?'':__t)+
'';
 } 
__p+='" data-id="'+
((__t=( color.get('id') ))==null?'':__t)+
'">\n      <div\n        style="';
 if (!color.get('displayFoilSwatch')) 
                    { 
__p+='\n                      background-color: rgb('+
((__t=( color.get('rgb') ))==null?'':__t)+
')\n                 ';
 } 
                   else { 
__p+='\n                      width: 0;height: 0;border-style: solid;border-width: 0 0 25px 25px; border-color: transparent transparent rgb('+
((__t=( color.get('rgb') ))==null?'':__t)+
') transparent;\n                 ';
 } 
__p+='\n              ">\n        <img alt="'+
((__t=( color.get('name') ))==null?'':__t)+
'"\n          src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n      </div>\n    </li>\n  ';
 }); 
__p+='\n</ul>\n';
}
return __p;
});

M.Template.ProductDetail.GreetingPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<h6>GREETINGS</h6>\n<ul>\n  ';
 _.each(greetings, function(greeting, idx) { 
__p+='\n    <li>\n      <a data-id="'+
((__t=( greeting.get('id') ))==null?'':__t)+
'"\n          data-label="'+
((__t=( greeting.get('displayName')))==null?'':__t)+
'"\n          data-internal-name="'+
((__t=( greeting.get('internalName') ))==null?'':__t)+
'"\n          class="greetingOption">\n        '+
((__t=( greeting.get('displayName') ))==null?'':__t)+
'\n      </a>\n    </li>\n  ';
 }); 
__p+='\n</ul>';
}
return __p;
});

M.Template.ProductDetail.HomeDecorFabricDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n\n';
 _.each(fabricOptionIds, function(fabricOptionId) { 
__p+='\n  <h4>'+
((__t=( M.html.htmlAttributeEscape(M.Model.ProductDetails.PAPER_OPTION_LABELS[fabricOptionId]) ))==null?'':__t)+
'</h4>\n  <p class="bm">\n    '+
((__t=( M.html.htmlAttributeEscape(M.View.ProductDetails.PAPER_CAPTIONS[fabricOptionId]) ))==null?'':__t)+
'\n  </p>\n';
 }); 
__p+='\n';
}
return __p;
});

M.Template.ProductDetail.MobileArtColorPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3>COLOR</h3>\n<div class="frame-wrapper">\n  <ul id="colorPicker">\n    ';
 _.each(colors, function(color, idx) { 
__p+='\n      <li class="swatch" data-id="'+
((__t=( color.get('id') ))==null?'':__t)+
'"\n          data-color-id="'+
((__t=( color.get('color_id') ))==null?'':__t)+
'"\n          data-foil-color="'+
((__t=( color.get('foil_color') ))==null?'':__t)+
'"\n          title="'+
((__t=( color.get('label') ))==null?'':__t)+
'">\n        <div class="colorPickerColor" style="background-color:'+
((__t=( color.get('rgb') ))==null?'':__t)+
';">\n          <img src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n        </div>\n      </li>\n    ';
 }); 
__p+='\n  </ul>\n  <p class="colorLabel caption"></p>\n</div>';
}
return __p;
});

M.Template.ProductDetail.MobileArtDimensionOption = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
 if (isFramed) { 
__p+='\n  '+
((__t=( model.get('dimensions') ))==null?'':__t)+
' - '+
((__t=( model.get('allFramedPrices')[selectedFrameOptionId] ))==null?'':__t)+
'\n';
 } else { 
__p+='\n  '+
((__t=( model.get('dimensions') ))==null?'':__t)+
' - '+
((__t=( model.get('unframedPrice') ))==null?'':__t)+
'\n';
 } 
__p+='';
}
return __p;
});

M.Template.ProductDetail.MobileArtDimensionPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<select id="dimension-picker"></select>';
}
return __p;
});

M.Template.ProductDetail.MobileArtFrameColorPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3>FRAME TYPE</h3>\n<div class="frame-wrapper">\n  <ul class="inline nm">\n    <li id="no-frame">\n        <div>No Frame</div>\n    </li>\n    \n    ';
 _.each(colors, function(color, idx) { 
__p+='\n      <li class="swatch" data-frame-color-id="'+
((__t=( color.get('id') ))==null?'':__t)+
'"\n          title="'+
((__t=( color.get('label') ))==null?'':__t)+
'"\n          data-recommended="'+
((__t=( color.get('recommended') ))==null?'':__t)+
'">\n        <div class="frameColor" style="background-color:#'+
((__t=( color.get('rgb') ))==null?'':__t)+
';">\n          <img src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n           class="'+
((__t=( color.get('internal_name')))==null?'':__t)+
'" />\n        </div>\n      </li>\n    ';
 }); 
__p+='\n  </ul>\n</div>\n<p class="frameColorLabel caption">\n  <span class="frameColorLabelText"></span><a class="moreFrameDescription">more</a>\n  <span class="frameDescription caption" style="display:none;"></span>\n</p>\n\n';
}
return __p;
});

M.Template.ProductDetail.MobileArtPaperPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3>\n  MATERIALS \n  <img class="sprite infoIcon" src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'" />\n</h3>\n<div class="paper-picker">\n  <select></select>\n</div>\n';
}
return __p;
});

M.Template.ProductDetail.MobileArtSignaturePicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h3>ARTIST SIGNATURE</h3>\n<ul class="nm">\n  <li>\n    <input type="checkbox" name="signatureOption" value="'+
((__t=( artistSignatureType ))==null?'':__t)+
'" />\n    <p>\n      '+
((__t=( M.html.htmlAttributeEscape(signatureTitle) ))==null?'':__t)+
' '+
((__t=( M.html.htmlAttributeEscape(signatureCaption) ))==null?'':__t)+
'\n    </p>\n  </li>\n</ul>';
}
return __p;
});

M.Template.ProductDetail.NoMatchedFrames = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p>Framing not available in this size.  We defaulted your selection to the next size down with framing available.</p>\n<a class="button button-last button-okay">\n  Okay\n</a>';
}
return __p;
});

M.Template.ProductDetail.PhotoViewPicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<h6>MORE VIEWS</h6>\n<ul>\n  ';
 _.each(photoViews, function(photoView, idx) { 
__p+='\n    <li>\n      <a data-id="'+
((__t=( photoView.get('id') ))==null?'':__t)+
'" class="photoViewOption">\n        '+
((__t=( photoView.get('description') ))==null?'':__t)+
'\n      </a>\n    </li>\n  ';
 }); 
__p+='\n</ul>';
}
return __p;
});

M.Template.ProductDetail.ShapePicker = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='';
/*
   * Copyright (C) 2015 Minted Inc.
   *
   * All Rights Reserved
   */
__p+='\n<h6>SHAPES</h6>\n<ul class="inline">\n  ';
 _.each(shapes, function(shape, idx) { 
__p+='\n    <li>\n      <a data-id="'+
((__t=( shape.get('id') ))==null?'':__t)+
'"\n      data-code="'+
((__t=(shape.get('code') ))==null?'':__t)+
'" class="shapeOption">\n        <img src="'+
((__t=( M.img_src('/static/images/sprite_placeholder.png') ))==null?'':__t)+
'"\n          class="dieCutSmallIcon '+
((__t=( shape.getOrientationCssClass() ))==null?'':__t)+
'\n          '+
((__t=( shape.get('name') ))==null?'':__t)+
'" />\n      </a>\n    </li>\n  ';
 }); 
__p+='\n</ul>';
}
return __p;
});

M.Template.ProductDetail.SharePdpDialog = M.templateWrapper(function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<!-- Template for Share Options modal dialog on the artPDP page -->\n\n<div class="share-dialog-buttons">\n  <a class="button button-ghost" href="mailto:?subject=Look%20at%20what%20I%20found%20on%20Minted.com&body=I%20found%20this%20great%20design,%20'+
((__t=( this.productName ))==null?'':__t)+
',%20on%20Minted.com.%20What%20do%20you%20think&#063;%20Take%20a%20look:%20'+
((__t=( this.productUrl ))==null?'':__t)+
'.">Email</a>\n\n  ';
 if (this.androidUserAgent) { 
__p+='\n    <a class="button button-ghost sms-button" href="sms:?body=I%20found%20this%20great%20design,%20'+
((__t=( this.productName ))==null?'':__t)+
',%20on%20Minted.com.%20What%20do%20you%20think&#063;%20Take%20a%20look:%20'+
((__t=( this.productUrl ))==null?'':__t)+
'.">SMS</a>\n  ';
 } else { 
__p+='\n    <a class="button button-ghost sms-button" href="sms:&body=I%20found%20this%20great%20design,%20'+
((__t=( this.productName ))==null?'':__t)+
',%20on%20Minted.com.%20What%20do%20you%20think&#063;%20Take%20a%20look:%20'+
((__t=( this.productUrl ))==null?'':__t)+
'.">SMS</a>\n  ';
 } 
__p+='\n\n  <div class="social-links"></div>\n  <a class="button cancel-button button-link button-last">Cancel</a>\n</div>\n';
}
return __p;
});


return {};

});
/* end templito generated file */
